<a class="product-item" [routerLink]="{ cxRoute: 'product', params: item.product } | cxUrl">
  <div class="product-item_container">
    <cx-media
      class="product-item_image"
      [container]="item.product.images?.PRIMARY"
      [alt]="item.product.name"
    ></cx-media>

    <div class="product-item_content">
      <div class="product-item_name text-b3-s-500 text-md-b3-m-500">
        {{ item.product.name }}
      </div>
      <p class="text-c1-s-300 text-md-b4-m-300">Товар отсутствует и будет удален из корзины</p>
    </div>
  </div>
</a>
